import z from 'zod';
import { EmployeeStatus } from './employees.types.js';
export const BeneficiaryKind = {
    employee: 'employee',
    ayantDroit: 'ayantDroit',
};
const isOrderedRange = (min, max) => min === null || max === null || min <= max;
export const faceValueCriteriaSchema = z
    .object({
    beneficiaryKinds: z.array(z.enum(BeneficiaryKind)),
    employeeStatuses: z.array(z.enum(EmployeeStatus)),
    ageMin: z.number().int("L'âge doit être un nombre entier").nonnegative().nullable(),
    ageMax: z.number().int("L'âge doit être un nombre entier").nonnegative().nullable(),
    coefficientMin: z.number().nonnegative().nullable(),
    coefficientMax: z.number().nonnegative().nullable(),
})
    .refine((criteria) => isOrderedRange(criteria.ageMin, criteria.ageMax), {
    message: "L'âge maximum doit être supérieur ou égal à l'âge minimum",
    path: ['ageMax'],
})
    .refine((criteria) => isOrderedRange(criteria.coefficientMin, criteria.coefficientMax), {
    message: 'Le coefficient maximum doit être supérieur ou égal au coefficient minimum',
    path: ['coefficientMax'],
});
export const NO_FACE_VALUE_CRITERIA = {
    beneficiaryKinds: [],
    employeeStatuses: [],
    ageMin: null,
    ageMax: null,
    coefficientMin: null,
    coefficientMax: null,
};
